import MyLocationIcon from "@mui/icons-material/MyLocation";
import ListItemIcon from "@mui/material/ListItemIcon";
import MenuItem from "@mui/material/MenuItem";
import Slider, { SliderProps } from "@mui/material/Slider";
import { useState } from "react";
import { useDataGridSettings } from "../DataGridSettingsProvider";
import { DiagnosticSettingsSlotProps } from "@/models/CustomColumnMenuProps";

export default function NumberPrecisionMenuItem(props: DiagnosticSettingsSlotProps) {
  const { field } = props;
  const { precisions, setPrecisions } = useDataGridSettings();
  const [sliderVal, setSliderVal] = useState(precisions?.[field] ?? 0);

  const handleChangeCommitted: SliderProps["onChangeCommitted"] = () => {
    setPrecisions(prev => ({ ...prev, [field]: sliderVal }));
  };

  const handleChange: SliderProps["onChange"] = (_: Event, newVal: number | number[]) => {
    if (typeof newVal === "number") {
      setSliderVal(newVal);
    }
  };

  return (
    <MenuItem>
      <ListItemIcon>
        <MyLocationIcon fontSize="small" />
      </ListItemIcon>
      <Slider
        value={sliderVal ?? 0}
        onChange={handleChange}
        onChangeCommitted={handleChangeCommitted}
        min={0}
        max={10}
        valueLabelDisplay="auto"
      />
    </MenuItem>
  );
}
